<template>
  <main-layout>
      <physician-component />
      <transition name="detail">
        <router-view class="detail-view" :key="detailViewId" />
      </transition>
  </main-layout>
</template>

<script>
import PhysicianComponent from '@/components/Physician'
export default {
  components: {PhysicianComponent},
  computed: {
    detailViewId () {
      if ('serial' in this.$route.params) return this.$route.params.serial
      return ''
    }
  }
}
</script>
